module.exports = __webpack_public_path__ + "static/media/sundorbon.53ce6f3b.jpg";